import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { motion } from "framer-motion";
import { SideGlowAmbience } from "./Ambience";

const faqs = [
  {
    q: "Combien de temps pour créer mon site ?",
    a: "Tout dépend de la formule. Un Lancement Express se livre en 7 à 10 jours, un Site Vitrine Complet en 2 à 4 semaines, et un projet sur-mesure entre 4 et 10 semaines. Nous validons un calendrier précis dès le brief stratégique.",
  },
  {
    q: "C'est vraiment adapté à mon type de commerce ?",
    a: "Oui — et c'est justement là que ML fait la différence. Salon, institut, laverie, restaurant, artisan, onglerie, barbier : chaque univers a sa personnalité, et un site immersif la met en scène. Peu importe votre secteur ou votre standing actuel : si votre commerce a de la valeur en vrai, il mérite de la montrer en ligne.",
  },
  {
    q: "Est-ce que ça va vraiment m'apporter des clients ?",
    a: "Un beau site ne suffit pas — il doit être trouvé et convaincre. C'est pourquoi chaque projet ML combine référencement local (pour apparaître sur Google quand on cherche votre activité près de chez vous) et parcours pensé pour la conversion (message clair en 5 secondes, contact en un clic). L'objectif n'est pas d'avoir un site : c'est d'avoir plus de clients.",
  },
  {
    q: "Proposez-vous un suivi après la mise en ligne ?",
    a: "Oui — un suivi technique de 30 jours est inclus dans chaque livraison, avec formation à la prise en main de votre site. Nous proposons également des offres de maintenance mensuelle pour ceux qui veulent rester totalement sereins.",
  },
  {
    q: "Mon site sera-t-il visible sur Google ?",
    a: "Le SEO est intégré dès la conception : balisage sémantique, performances Core Web Vitals, structure optimisée, sitemap, schema.org. Nous travaillons aussi le référencement local pour les artisans et professions de proximité.",
  },
  {
    q: "Travaillez-vous uniquement en Île-de-France ?",
    a: "Pas du tout. Nous travaillons à distance avec des clients dans toute la France et à l'international. Tous les échanges se font par visio, mail ou téléphone — au rythme qui vous convient.",
  },
  {
    q: "Que se passe-t-il si je ne suis pas satisfait ?",
    a: "Le design est validé par votre soin avant tout développement, ce qui élimine 95 % des mauvaises surprises. Si malgré tout un point ne vous convient pas après livraison, nous le retravaillons sans frais — la relation prime sur la transaction.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative overflow-hidden py-28 sm:py-40 px-5 sm:px-8 lg:px-12 border-t border-white/[0.06]"
    >
      <SideGlowAmbience />
      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500 mb-6 block">
              (07) — FAQ
            </span>
            <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tighter mb-6">
              Questions <br />
              <span className="text-outline">fréquentes</span>
            </h2>
            <p className="text-zinc-400 leading-relaxed max-w-sm">
              Toutes les réponses avant de démarrer. Une autre question en tête ? Écrivez-nous, on répond sous 24h.
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-white/[0.08] last:border-b-0"
                >
                  <AccordionTrigger
                    className="font-display text-left text-2xl sm:text-3xl tracking-tight hover:no-underline py-7 hover:text-[var(--accent)] transition-colors data-[state=open]:text-[var(--accent)]"
                  >
                    <span className="flex items-center gap-5">
                      <span className="font-mono text-sm text-zinc-500 shrink-0">
                        0{i + 1}
                      </span>
                      {f.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-zinc-400 text-base leading-relaxed pb-7 pl-12 max-w-2xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
